import React from 'react';
import { ArrowLeft } from 'lucide-react';
export function PrivacyPage({
  onBack
}: {
  onBack: () => void;
}) {
  return <div className="min-h-screen bg-cream" data-id="element-212">
      {/* Header */}
      <header className="bg-navy-900 border-b border-navy-800" data-id="element-213">
        <div className="max-w-3xl mx-auto px-4 py-5 flex items-center" data-id="element-214">
          <button onClick={onBack} className="inline-flex items-center gap-2 text-gray-400 hover:text-teal-400 transition-colors text-sm font-medium" data-id="element-215">
            <ArrowLeft className="h-4 w-4" data-id="element-216" />
            Back to home
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-4 py-16" data-id="element-217">
        <h1 className="text-3xl md:text-4xl font-bold text-navy-800 font-serif mb-3" data-id="element-218">
          Privacy Policy
        </h1>
        <p className="text-sm text-text-body mb-10 border-b border-gray-200 pb-6" data-id="element-219">
          Last updated:{' '}
          {new Date().toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })}
        </p>

        <div className="space-y-8 text-text-body leading-relaxed" data-id="element-220">
          <section data-id="element-221">
            <h2 className="text-xl font-bold text-navy-800 font-serif mb-3" data-id="element-222">
              1. Information We Collect
            </h2>
            <p data-id="element-223">
              When you purchase CPAP Compliance Rescue, we collect only the
              information necessary to process your order: your name, email
              address, and payment information. Payment processing is handled by
              our secure third-party payment processor — we never store your
              credit card details.
            </p>
          </section>

          <section data-id="element-224">
            <h2 className="text-xl font-bold text-navy-800 font-serif mb-3" data-id="element-225">
              2. How We Use Your Information
            </h2>
            <p data-id="element-226">
              Your email address is used to deliver your digital purchase and,
              if you opt in, to send occasional helpful content related to CPAP
              therapy. We will never sell, rent, or share your personal
              information with third parties for marketing purposes.
            </p>
          </section>

          <section data-id="element-227">
            <h2 className="text-xl font-bold text-navy-800 font-serif mb-3" data-id="element-228">
              3. Health Information
            </h2>
            <p data-id="element-229">
              We do not collect, store, or have access to any of your health or
              medical data. The worksheets and logs included in the guide are
              for your personal use only and remain on your device or in your
              printed copies.
            </p>
          </section>

          <section data-id="element-230">
            <h2 className="text-xl font-bold text-navy-800 font-serif mb-3" data-id="element-231">
              4. Cookies & Analytics
            </h2>
            <p data-id="element-232">
              This website may use basic analytics to understand how visitors
              find and use this page. No personally identifiable health
              information is tracked. You can disable cookies in your browser
              settings at any time.
            </p>
          </section>

          <section data-id="element-233">
            <h2 className="text-xl font-bold text-navy-800 font-serif mb-3" data-id="element-234">
              5. Data Security
            </h2>
            <p data-id="element-235">
              We use industry-standard SSL encryption to protect your
              information during transmission. Your data is stored securely and
              accessed only as needed to fulfill your order.
            </p>
          </section>

          <section data-id="element-236">
            <h2 className="text-xl font-bold text-navy-800 font-serif mb-3" data-id="element-237">
              6. Your Rights
            </h2>
            <p data-id="element-238">
              You may request access to, correction of, or deletion of your
              personal data at any time. To make a request, contact us using the
              information provided in your purchase confirmation email.
            </p>
          </section>

          <section data-id="element-239">
            <h2 className="text-xl font-bold text-navy-800 font-serif mb-3" data-id="element-240">
              7. Changes to This Policy
            </h2>
            <p data-id="element-241">
              We may update this policy from time to time. Any changes will be
              reflected on this page with an updated date.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200" data-id="element-242">
          <button onClick={onBack} className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 transition-colors font-medium" data-id="element-243">
            <ArrowLeft className="h-4 w-4" data-id="element-244" />
            Back to home
          </button>
        </div>
      </main>
    </div>;
}